import { useState, useEffect, useRef } from "react";

import { Button } from "../ui/button";
import { DownloadIcon, QuestionMarkIcon } from "@radix-ui/react-icons";
import html2canvas from "html2canvas";
import download from "downloadjs";
import { useHistory } from "react-router-dom";

import { TabView, TabPanel } from "primereact/tabview";

import AproveitamentoCard from "../AproveitamentoCard";
import TabelaAproveitamentoColaborador from "../AproveitamentoColaboradorTabela";
import ChartBar from "../Chart";
import { DatePickerWithRange } from "../ui/date-range-picker";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";

import { MultiSelect } from "primereact/multiselect";

import "./styles.css";

import api from "../../services/api";

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import Pivottable from "../Pivottable/pivottable";
import Tour from "../Tour";
import { useTour } from "@reactour/tour";
import { stepsColaborador, stepsProject, stepsPivottable } from "../Tour/steps";
import * as XLSX from "xlsx/xlsx.mjs";
import Produtividade from "./produtividade";

export default function RelatorioDeProjeto() {
  const history = useHistory();
  const { setSteps } = useTour();
  const [header, setHeader] = useState(0);
  const exportProjectChart = useRef(null);
  const exportColaboradorChart = useRef(null);
  const [projetos, setProjetos] = useState([]);
  const [epicos, setEpicos] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [colaboradorSelecionado, setColaboradorSelecionado] = useState("");
  const [colaboradorTitulo, setcolaboradorTitulo] = useState("");
  const [epicoSelecionado, setEpicoSelecionado] = useState("");
  const [epicosSelecionadosColaborador, setEpicosSelecionadosColaborador] =
    useState([]);
  const [projetoSelecionado, setProjetoSelecionado] = useState("");
  const [projetoSelecionadoTitulo, setProjetoSelecionadoTitulo] = useState("");
  const [projetosSelecionadoColaborador, setProjetosSelecionadosColaborador] =
    useState([]);
  const [projetosSelecionadoPivottable, setProjetosSelecionadosPivottable] =
    useState([]);
  const [datesProject, setDatesProject] = useState([]);
  const [datesColaborador, setDatesColaborador] = useState(null);
  const [datesPivottable, setDatesPivottable] = useState(null);
  const [dadosPivottable, setdadosPivottable] = useState([]);
  const [objectChart, setObjectChart] = useState({});
  const [objectChartColaborador, setObjectChartColaborador] = useState({});
  const [dadosTabelaColaborador, setDadosTabelaColaborador] = useState([]);
  const [opcoesEpicosColaborador, setOpcoesEpicosColaborador] = useState([]);

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        let token = localStorage.getItem("auth-token");
        const response = await api.get("/api/user/perfil", {
          headers: { "x-auth-token": token },
        });
        const userData = response.data;
        if (!userData.isProjectManager) {
          return history.push("/perfil");
        }
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
      }
    };

    getUserInfo();
    if (projetosSelecionadoColaborador.length > 0) {
      const opcoesAtualizadas = epicos
        .filter((epico) =>
          projetosSelecionadoColaborador.some(
            (projeto) => projeto === epico.id_projeto
          )
        )
        .map((epico) => ({
          label:
            epico.nome.length > 22
              ? epico.nome.slice(0, 22) + "..."
              : epico.nome,
          value: epico.id,
        }));
      setOpcoesEpicosColaborador(opcoesAtualizadas);
    } else {
      setOpcoesEpicosColaborador([]);
    }
  }, [projetosSelecionadoColaborador, epicos, history]);

  useEffect(() => {
    const getProjetos = async () => {
      try {
        const response = await api.get("/api/planejamentoProjetos");
        const projetosData = response.data;
        setProjetos(projetosData);
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
      }
    };

    getProjetos();
  }, []);

  useEffect(() => {
    const getColaboradores = async () => {
      try {
        const response = await api.get("api/buscarColaboradores");
        setColaboradores(response.data);
      } catch (error) {
        console.error("Erro ao atualizar o registro:", error);
      }
    };
    getColaboradores();
  }, []);

  useEffect(() => {
    if (header === 0) {
      setSteps(stepsProject);
    } else if (header === 1) {
      setSteps(stepsColaborador);
    } else if (header === 2) {
      setSteps(stepsPivottable);
    }
  }, [header, setSteps]);

  useEffect(() => {
    const getEpicos = async () => {
      try {
        const response = await api.get("/api/buscarEpicos");
        const epicosData = response.data;
        setEpicos(epicosData);
      } catch (error) {
        console.error("Erro ao buscar epicos:", error);
      }
    };

    getEpicos();
  }, []);

  useEffect(() => {
    const getEpicos = async () => {
      try {
        const response = await api.get("/api/buscarEpicos");
        const epicosData = response.data;
        setEpicos(epicosData);
      } catch (error) {
        console.error("Erro ao buscar epicos:", error);
      }
    };

    getEpicos();
  }, []);

  const handleExportProjectChartClick = async () => {
    const chartContainer = exportProjectChart.current;

    try {
      const btnDownload = chartContainer.querySelector("#btn-download");
      const tooltipInformation = chartContainer.querySelector("#information");

      if (btnDownload && tooltipInformation) {
        btnDownload.style.display = "none";
        tooltipInformation.style.display = "none";
      }

      await new Promise((resolve) => setTimeout(resolve, 100));

      const canvas = await html2canvas(chartContainer);
      const dataUrl = canvas.toDataURL("image/png");
      download(dataUrl, "exported-image.png", "image/png");
    } catch (error) {
      console.error("Erro ao exportar para PNG:", error);
    } finally {
      const btnDownload = chartContainer.querySelector("#btn-download");
      const tooltipInformation = chartContainer.querySelector("#information");

      if (btnDownload && tooltipInformation) {
        btnDownload.style.display = "";
        tooltipInformation.style.display = "";
      }
    }
  };

  const handleExportColaboradorTable = async () => {
    const columnHeaders = {
      titulo_hu: "Título da atividade",
      status_hu: "Status",
      nome_projeto: "Projeto relacionado",
      nome_epico: "Épico relacionado",
      data_inicio: "Data Inicio",
      data_fim: "Data Fim",
      tempo_esperado: "Previsto",
      tempo_gasto: "Realizado",
    };

    const tableData = dadosTabelaColaborador.map((row) =>
      Object.keys(row).reduce((acc, key) => {
        if ((key === "data_inicio" || key === "data_fim") && row[key]) {
          const formattedDate = new Date(row[key]).toLocaleDateString('pt-BR')
          acc[columnHeaders[key]] = formattedDate;
        } else {
          acc[columnHeaders[key]] = row[key];
        }
        return acc;
      }, {})
    );

    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Atividades Colaborador");
    XLSX.writeFile(workbook, "atividades-colaborador.xlsx");
  };

  const fetchDataProject = async () => {
    try {
      if (datesProject.length === 0) {
        return;
      }

      const id_projeto = projetos.find(
        (projeto) => projeto.nome === projetoSelecionado
      )?.id;
      const id_epico = epicos.find(
        (epico) => epico.nome === epicoSelecionado
      )?.id;

      const queryParams = {};

      if (id_projeto && datesProject.length > 0) {
        queryParams.id_projeto = id_projeto;
        queryParams.datesProject = datesProject;
      }

      if (id_epico) {
        queryParams.id_epico = id_epico;
      }

      const queryString = new URLSearchParams(queryParams).toString();

      const response = await api.get(
        `/api/relatorioProjeto/projeto?${queryString}`,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      setObjectChart(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const opcoesProjetosMultiselect = projetos.map((projeto) => ({
    label: projeto.nome,
    value: projeto.id,
  }));

  const handleDataFilteredProject = async () => {
    if (
      (projetoSelecionado !== "0" && datesProject.length !== 0) ||
      epicoSelecionado !== "0"
    ) {
      setProjetoSelecionadoTitulo(projetoSelecionado);
      await fetchDataProject();
    }
  };

  function prepararDadosParaChart(data) {
    const projetoMap = {};
  
    data.forEach(row => {
      const { nome_projeto, tempo_esperado, tempo_gasto } = row;
  
      const tempoEstimado = Number(tempo_esperado) || 0;
      const tempoGasto = Number(tempo_gasto) || 0;
  
      if (!projetoMap[nome_projeto]) {
        projetoMap[nome_projeto] = {
          nome_projeto,
          tempoEstimado,
          tempoGasto,
        };
      } else {
        projetoMap[nome_projeto].tempoEstimado += tempoEstimado;
        projetoMap[nome_projeto].tempoGasto += tempoGasto;
      }
    });
  
    const nomesProjetos = Object.keys(projetoMap);
    const tempoEstimadoColaborador = nomesProjetos.map(projeto => projetoMap[projeto].tempoEstimado);
    const tempoGastoColaborador = nomesProjetos.map(projeto => projetoMap[projeto].tempoGasto);
  
    return {
      nomesProjetos,
      tempoEstimadoColaborador,
      tempoGastoColaborador,
    };
  }
  

  const fetchFilteredUserHistoriesColaborador = async () => {
    if (colaboradorSelecionado === "0") {
      return;
    }

    if (datesColaborador.length < 0) {
      return setObjectChartColaborador([]);
    }
    setcolaboradorTitulo(colaboradorSelecionado);
    const id_colaborador = colaboradores.find(
      (colaborador) => colaborador.nome === colaboradorSelecionado
    )?.id;

    if (
      id_colaborador &&
      epicosSelecionadosColaborador.length > 0 &&
      datesColaborador.length > 0
    ) {
      const responseTable = await api.get("/api/relatorio/colaborador", {
        params: {
          id_colaborador: id_colaborador,
          id_projeto: projetosSelecionadoColaborador.join(","),
          datesColaborador: datesColaborador.join(","),
          id_epicos: epicosSelecionadosColaborador.join(","),
        },
        headers: { "Content-Type": "application/json" },
      });
      setDadosTabelaColaborador(responseTable.data);
      const dadosChart = prepararDadosParaChart(responseTable.data);
      setObjectChartColaborador(dadosChart);
      return
    }

    if (
      projetosSelecionadoColaborador.length > 0 &&
      id_colaborador &&
      datesColaborador.length > 0
    ) {
      const responseTable = await api.get("/api/relatorio/colaborador", {
        params: {
          id_colaborador: id_colaborador,
          id_projeto: projetosSelecionadoColaborador.join(","),
          datesColaborador: datesColaborador.join(","),
        },
        headers: { "Content-Type": "application/json" },
      });
      setDadosTabelaColaborador(responseTable.data);
      const dadosChart = prepararDadosParaChart(responseTable.data);
      setObjectChartColaborador(dadosChart);
      return;
    }

    if (id_colaborador && datesColaborador.length > 0) {
      const responseTable = await api.get("/api/relatorio/colaborador", {
        params: {
          id_colaborador: id_colaborador,
          datesColaborador: datesColaborador?.join(","),
        },
        headers: { "Content-Type": "application/json" },
      });
      setDadosTabelaColaborador(responseTable.data);
      const dadosChart = prepararDadosParaChart(responseTable.data);
      setObjectChartColaborador(dadosChart);
      return;
    }

    return;
  };

  const fetchFilteredDataPivottable = async () => {
    try {
      const queryParams = {};

      if (
        datesPivottable.length > 0 &&
        projetosSelecionadoPivottable.length > 0
      ) {
        queryParams.datesPivottable = datesPivottable;
        queryParams.projetos = projetosSelecionadoPivottable;
        const queryString = new URLSearchParams(queryParams).toString();

        const response = await api.get(
          `/api/getDataPivottable?${queryString}`,
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        setdadosPivottable(response.data);
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSelecaoProjetosColaborador = (event) => {
    setProjetosSelecionadosColaborador(event.value);
  };
  const handleSelecaoProjetosPivottable = (event) => {
    setProjetosSelecionadosPivottable(event.value);
  };

  const handleSelecaoEpicosColaborador = (event) => {
    setEpicosSelecionadosColaborador(event.value);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <nav
          className="navigation"
          style={{
            marginTop: "100px",
          }}
        >
          <ul>
            <li>
              <a href="/perfil">Home</a>
            </li>
            <li>/</li>
            <li>
              <a href="/relatorio-projeto/#">Gestão de Projetos</a>
            </li>
            <li>/</li>
            <li>
              <a href="/relatorio-projeto">Relatório de Projeto</a>
            </li>
          </ul>
        </nav>
        <div
          style={{
            width: "95%",
            display: "flex",
            justifyContent: "center",
            borderBottom: "2px solid #006998",
            marginBottom: "3rem",
          }}
        >
          <p
          className="relatorio-title"
            style={{
              fontSize: "35px",
              fontWeight: "700",
              color: "#00293B",
              fontFamily: "satoshi",
              marginTop: "5px",
              marginBottom: "5px",
            }}
          >
            Relatório de Projeto
          </p>
        </div>

        <div style={{ width: "95%" }}>
          <TabView
            activeIndex={header}
            onTabChange={(e) => {
              setHeader(e.index);
            }}
          >
            <TabPanel className="projectHeader" header="Projetos">
              <p className="filter-title">Filtrar por:</p>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  padding: "1rem 1rem 1rem 0",
                  alignItems: "center",
                  gap: "1rem",
                }}
              >
                <Select
                  value={projetoSelecionado}
                  onValueChange={(value) => {
                    setProjetoSelecionado(value);
                    setEpicoSelecionado("");
                  }}
                >
                  <SelectTrigger className="w-[240px] selectProject">
                    <SelectValue placeholder="Projeto" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem key={-1} value={"0"}>
                        Selecione um Projeto
                      </SelectItem>
                      {projetos.map((projeto) => (
                        <SelectItem key={projeto.id} value={projeto.nome}>
                          {projeto.nome}
                        </SelectItem>
                      ))}
                    </SelectGroup>
                  </SelectContent>
                </Select>
                <Select
                  value={epicoSelecionado}
                  onValueChange={(value) => {
                    setEpicoSelecionado(value);
                  }}
                >
                  <SelectTrigger className="w-[240px] epicsProject">
                    <SelectValue placeholder="Epico" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem key={-1} value={"0"}>
                        Selecione um Épico
                      </SelectItem>
                      {epicos
                        ?.filter(
                          (epico) =>
                            projetos.find(
                              (projeto) => projeto.nome === projetoSelecionado
                            )?.id === epico?.id_projeto
                        )
                        .map((epico) => (
                          <SelectItem key={epico.id} value={epico.nome}>
                            {epico.nome}
                          </SelectItem>
                        ))}
                    </SelectGroup>
                  </SelectContent>
                </Select>
                <DatePickerWithRange
                  className="datesProject"
                  setDates={setDatesProject}
                />
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        disabled={
                          !(projetoSelecionado && datesProject.length > 0)
                        }
                        className="bg-[#3900DB] buttonApplyFiltersProject"
                        onClick={handleDataFilteredProject}
                      >
                        Aplicar filtros
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent className="w-30">
                      <span className="c-#fff">
                        Selecione pelo menos um projeto e um período de tempo.
                      </span>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              </div>

              {Object.keys(objectChart).length > 0 ? (
                <div ref={exportProjectChart}>
                  <div className="title-project-wrapper">
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <Button
                            id="information"
                            variant="destructive"
                            size="icon"
                          >
                            <QuestionMarkIcon className=""></QuestionMarkIcon>
                          </Button>
                        </TooltipTrigger>
                        <TooltipContent className="w-30">
                          <span className="c-#fff">
                            *Só serão contabilizadas as atividades que tiverem o
                            campo data de início preenchido
                            <br/>
                            **O eixo x é baseado nos meses da data de inicio das atividades
                          </span>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                    <p>{projetoSelecionadoTitulo}</p>

                    <DownloadIcon
                      id="btn-download"
                      className={`h-[40px] w-[40px] text-[#3900DB] cursor-pointer d-block`}
                      onClick={handleExportProjectChartClick}
                    ></DownloadIcon>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "center",
                      paddingBottom: "1rem",
                    }}
                  >
                    {" "}
                    <AproveitamentoCard
                      totalObject={objectChart}
                    ></AproveitamentoCard>
                  </div>

                  <p
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    TOTAL DE HORAS ESTIMADAS/TOTAL DE HORAS REALIZADAS
                  </p>
                  <div style={{ height: "60%" }}>
                    <ChartBar dataObject={objectChart}></ChartBar>
                  </div>
                </div>
              ) : (
                <p>Sem dados para serem exibidos</p>
              )}
            </TabPanel>

            <TabPanel className="colaboradorHeader" header="Colaborador">
              <p className="filter-title">Filtrar por:</p>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  padding: "1rem",
                  alignItems: "center",
                  gap: "1rem",
                }}
              >
                <Select
                  value={colaboradorSelecionado}
                  onValueChange={(value) => {
                    setColaboradorSelecionado(value);
                  }}
                  className="d-block"
                >
                  <SelectTrigger className="w-[300px] selectColaborador">
                    <SelectValue placeholder="Colaborador" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem key={-1} value={"0"}>
                        Selecione um Colaborador
                      </SelectItem>
                      {colaboradores.map((colaborador) => (
                        <SelectItem
                          key={colaborador.id}
                          value={colaborador.nome}
                        >
                          {colaborador.nome}
                        </SelectItem>
                      ))}
                    </SelectGroup>
                  </SelectContent>
                </Select>
                <MultiSelect
                  className="selectProjectsColaborador"
                  style={{ width: "20rem" }}
                  placeholder="Projetos"
                  value={projetosSelecionadoColaborador}
                  options={opcoesProjetosMultiselect}
                  onChange={handleSelecaoProjetosColaborador}
                  maxSelectedLabels={4}
                />
                <MultiSelect
                  className="selectEpicsColaborador"
                  style={{ width: "20rem" }}
                  placeholder="Épicos"
                  maxSelectedLabels={4}
                  options={opcoesEpicosColaborador}
                  value={epicosSelecionadosColaborador}
                  onChange={handleSelecaoEpicosColaborador}
                ></MultiSelect>
                <DatePickerWithRange
                  className="datesColaborador"
                  setDates={setDatesColaborador}
                />
                <TooltipProvider>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Button
                        disabled={
                          !(
                            colaboradorSelecionado &&
                            datesColaborador.length > 0
                          )
                        }
                        onClick={fetchFilteredUserHistoriesColaborador}
                        className="bg-[#3900DB] buttonApplyFiltersColaborador"
                      >
                        Aplicar filtros
                      </Button>
                    </TooltipTrigger>
                    <TooltipContent className="w-30">
                      <span className="c-#fff">
                        Selecione pelo menos um colaborador e um período de
                        tempo.
                      </span>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              </div>
              {objectChartColaborador?.nomesProjetos &&
              objectChartColaborador?.nomesProjetos.length > 0 ? (
                <>
                  <div ref={exportColaboradorChart}>
                    <div className="title-project-wrapper">
                      <p>{colaboradorTitulo}</p>
                      <DownloadIcon
                        id="btn-download"
                        className="h-[40px] w-[40px] text-[#3900DB] cursor-pointer"
                        onClick={handleExportColaboradorTable}
                      ></DownloadIcon>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "center",
                        paddingBottom: "1rem",
                      }}
                    >
                      <AproveitamentoCard
                        totalObject={objectChartColaborador}
                      ></AproveitamentoCard>
                    </div>

                    <p
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      Aproveitamento por projeto
                    </p>
                    <div style={{ height: "60%" }}>
                      <ChartBar
                        dataObject={objectChartColaborador}
                        colaborador={colaboradorSelecionado}
                      ></ChartBar>
                    </div>
                  </div>
                  <TabelaAproveitamentoColaborador
                    idColaborador={
                      colaboradores.find(
                        (colaborador) =>
                          colaborador.nome === colaboradorSelecionado
                      )?.id
                    }
                    projetoSelecionado={projetosSelecionadoColaborador}
                    dadosTabelaColaborador={dadosTabelaColaborador}
                  ></TabelaAproveitamentoColaborador>
                </>
              ) : (
                <p>Sem dados para serem exibidos</p>
              )}
            </TabPanel>
            <TabPanel header="Aspectos analíticos">
              <p className="filter-title">Filtrar por:</p>
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  padding: "1rem",
                  
                }}
              >
                <MultiSelect
                  className="selectProjectsPivottable"
                  style={{ width: "15rem" }}
                  placeholder="Projetos"
                  value={projetosSelecionadoPivottable}
                  options={opcoesProjetosMultiselect}
                  onChange={handleSelecaoProjetosPivottable}
                  maxSelectedLabels={4}
                />

                <DatePickerWithRange
                  className="datesPivottable"
                  setDates={setDatesPivottable}
                />

                <Button
                  disabled={
                    !(
                      projetosSelecionadoPivottable.length > 0 &&
                      projetosSelecionadoPivottable.length > 0
                    )
                  }
                  onClick={fetchFilteredDataPivottable}
                  className="bg-[#3900DB] buttonApplyFiltersPivottable"
                >
                  Aplicar filtros
                </Button>
              </div>

              {dadosPivottable.length > 0 ? (
                <>
                  <p
                  className="aspectosAnaliticosHeader"
                    style={{
                      display: "flex",
                      width: "100%",
                      textAlign: "center",
                      fontSize: "2rem",
                      fontFamily: "Satoshi",
                      color: "#006998",
                      justifyContent: "center",
                      fontWeight: "600",
                    }}
                  >
                    Aspectos Analíticos
                  </p>
                  <p
                    style={{
                      fontFamily: "Satoshi",
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "4rem",
                    }}
                  >
                    Arraste as variáveis para a área de
                    <span
                      style={{
                        fontWeight: "600",
                        marginLeft: ".3rem",
                        marginRight: ".3rem",
                      }}
                    >
                      {" "}
                      linhas{" "}
                    </span>{" "}
                    ou
                    <span style={{ fontWeight: "600", marginLeft: ".3rem" }}>
                      {" "}
                      colunas
                    </span>
                    .
                  </p>
                  <div
                    style={{
                      display: "flex",
                      overflowX: "auto",
                    }}
                  >
                    <Pivottable data={dadosPivottable}></Pivottable>
                  </div>
                </>
              ) : (
                <span style={{ fontFamily: "Satoshi" }}>
                  Sem dados para serem exibidos.
                </span>
              )}
            </TabPanel>
            <TabPanel header="Produtividade">
              <Produtividade />
            </TabPanel>
          </TabView>
        </div>
      </div>
      
        <Tour></Tour>
      
    </>
  );
}
